import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Outlet } from "../outlet.model";
import { OutletService } from "../outlet.service";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/switchMap";
import { Observable } from "rxjs/Observable";
import { get } from "lodash";
import { AppRoutingService } from "../../app-routing.service";
import { OutletListResponse } from "../Outlet-list-reponse.model";

@Component({
  selector: "app-outlet-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class OutletListComponent implements OnInit {
  alerts: any = {
    newOutletAdded: {
      show: false,
      type: "success",
      msg: "Outlet registered successfully",
    },
    outletUpdated: {
      show: false,
      type: "success",
      msg: "Outlet updated successfully",
    },
    error: {
      show: false,
      type: "danger",
      msg: "An error occurred",
    },
  };

  showAlert: boolean;

  outletList: Array<Outlet>;

  outletListResponse: OutletListResponse;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private outletService: OutletService,
    private routingService: AppRoutingService
  ) {
    this.outletList = new Array<Outlet>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.alerts.newOutletAdded.show = this.outletService.hasJustRegistered;
    this.alerts.outletUpdated.show = this.outletService.hasJustUpdated;

    this.outletService.hasJustRegistered = false;
    this.outletService.hasJustUpdated = false;
    this.getOutletsList();
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }

  private getOutletsList(): void {
    const data = this.route.snapshot.data;
    this.outletListResponse = get(data, ['outlet'], []);
    this.outletList = this.outletListResponse.data;
    if (this.outletList.length === 0) {
      this.showAlert = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/outlet/list/list.component.ts